export const isSlotActive = (slot) => {
  if (!slot?.date || !slot?.startTime || !slot?.endTime) return false;

  const now = new Date();

  const start = new Date(`${slot.date}T${slot.startTime}`);
  const end = new Date(`${slot.date}T${slot.endTime}`);

  const startWindow = new Date(start.getTime() - 60 * 60 * 1000);
  const endWindow = new Date(end.getTime() + 60 * 60 * 1000);

  return now >= startWindow && now <= endWindow;
};